<template>
<div>
    <!--Contenido del boton agregar un periodo-->
    <div class="centerx">
        <vs-popup classContent="popup-example" :title="titleModal" :active.sync="popupActivo2">
            <div class="vx-col w-full mt-5">
                <label>Fecha inicial</label>
                <vs-input class="inputx w-full" type="date" v-model="periodo2.fecha_inicial" />
            </div>
            <div class="vx-col w-full mt-5">
                <label>Fecha Final</label>
                <vs-input class="inputx w-full" type="date" v-model="periodo2.fecha_final" />
            </div>
            <div class="vx-col w-full mt-5">
                <label>Descripcion</label>
                <vs-input class="inputx w-full" placeholder="Descripcion" v-model="periodo2.descripcion" />
            </div>
            <div class="vx-col w-full mt-5">
                <!-- <label>Region</label> -->
                <ul class="leftx">
                    <li class="modelx">
                        Seleccione la region
                    </li>
                    <br>
                    <li>
                        <vs-radio v-model="periodo2.region_idregion" vs-name="radios1" vs-value="1">Sierra</vs-radio>
                    </li>
                    <li>
                        <vs-radio v-model="periodo2.region_idregion" vs-name="radios1" vs-value="2">Costa</vs-radio>
                    </li>
                </ul>
            </div>
            <div class="vx-col w-full mt-5">
                <label>Periodo escolar</label>
                <vs-input class="inputx w-full" placeholder="Periodo escolar" v-model="periodo2.periodoescolar" />
            </div>

            <br>
            <vs-button @click="agregarPeriodo();" color="primary" type="filled">Guardar Cambios</vs-button>
        </vs-popup>
    </div>
    <!--FIN DEL CONTENIDO POPUP PARA AGREGAR UN Agregar -->
    <!--  CONTENIDO POPUP PARA AGREGAR UN Editar -->
    <div class="centerx">
        <vs-popup classContent="popup-example" :title="titleModal" :active.sync="popupActivo1">
            <div class="vx-col w-full mt-5">
                <label>Fecha inicial</label>
                <vs-input class="inputx w-full" type="date" v-model="periodo.fecha_inicial" />
            </div>
            <div class="vx-col w-full mt-5">
                <label>Fecha Final</label>
                <vs-input class="inputx w-full" type="date" v-model="periodo.fecha_final" />
            </div>
            <div class="vx-col w-full mt-5">
                <label>Descripcion</label>
                <vs-input class="inputx w-full" placeholder="Descripcion" v-model="periodo.descripcion" />
            </div>
            <div class="vx-col w-full mt-5">
                <!-- <label>Region</label> -->
                <ul class="leftx">
                    <li class="modelx">
                        Seleccione la región
                    </li>
                    <br>
                    <li>
                        <vs-radio v-model="periodo.region_idregion" vs-name="radios1" vs-value="1">Sierra</vs-radio>
                    </li>
                    <li>
                        <vs-radio v-model="periodo.region_idregion" vs-name="radios1" vs-value="2">Costa</vs-radio>
                    </li>
                </ul>
            </div>
            <div class="vx-col w-full mt-5">
                <label>Periodo escolar</label>
                <vs-input class="inputx w-full" placeholder="Periodo escolar" v-model="periodo.periodoescolar" />
            </div>

            <br>
            <vs-button @click="agregarPeriodo();" color="primary" type="filled">Guardar Cambios</vs-button>
        </vs-popup>
    </div>
    <!-- FIN POPUP DE EDITAR-->
    <div>
        <!--Tabla para el listado de la tabla periodos-->
        <vs-table stripe max-items="50" search pagination :data="periodoLista">
            <template slot="header">
                <vs-button @click="addPeriodo();" type="border">
                    + Agregar periodo
                </vs-button>
            </template>
            <template slot="thead">
                <vs-th>Nombre</vs-th>
                <vs-th>Periodo</vs-th>
                <vs-th>Region</vs-th>
                <vs-th>Fechas</vs-th>
                <vs-th>Estado</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].descripcion">
                        {{data[indextr].descripcion}}
                    </vs-td>
                    <vs-td :data="data[indextr].periodoescolar">
                        {{data[indextr].periodoescolar}}
                        <div>
                            id - {{ tr.idperiodoescolar }}
                        </div>
                    </vs-td>

                    <vs-td :data="data[indextr].region_idregion">
                        <label v-if="data[indextr].region_idregion == '1'">SIERRA</label>
                        <label v-if="data[indextr].region_idregion == '2'">COSTA</label>
                    </vs-td>

                    <vs-td :data="data[indextr].fhasta_limite">
                        <p style="font-weight:bold;">Fecha inicio:</p>
                        <span>{{tr.fecha_inicial}}</span>
                        <p style="font-weight:bold;">Fecha final:</p>
                        <span>{{tr.fecha_final}}</span>
                    </vs-td>

                    <vs-td :data="data[indextr].estado">
                        <label v-if="data[indextr].estado == '1'" class="text-success">Activo</label>
                        <label v-if="data[indextr].estado == '0'" class="text-danger">Inactivo</label>
                    </vs-td>
                    <vs-td :data="tr">
                        <div class="flex">
                            <!-- <vs-button type="border" size="small" icon-pack="feather" icon="icon-info" class="mr-2" color="primary" @click="getInformacion(tr)"></vs-button> -->

                            <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" color="success" @click="update = true; openModal(data[indextr]);"></vs-button>
                            <vs-button type="border" v-if="data[indextr].estado == '1'" size="small" icon-pack="feather" icon="icon-x" class="mr-2" color="danger" @click="desactivar(data[indextr].idperiodoescolar)"></vs-button>
                            <vs-button color="primary" v-if="data[indextr].estado == '0'" size="small" type="border" icon-pack="feather" icon="icon-check" @click="activar(data[indextr].idperiodoescolar)"></vs-button>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'PeriodosVue',
    data: () => ({
        //para el modal 
        popupActivo1: false,
        popupActivo2: false,
        //para actualizar
        update: true,
        id: 0,
        titleModal: '',
        periodoLista: [],
        usuario: '',
        usuario_id: '',
        periodo: {
            fecha_inicial: '',
            fecha_final: '',
            descripcion: '',
            region_idregion: '1',
            periodoescolar: '',
            fromDate: null,
            toDate: null,
        },
        periodo2: {
            fecha_inicial: '',
            fecha_final: '',
            descripcion: '',
            region_idregion: '1',
            periodoescolar: '',
            fromDate: null,
            toDate: null,
        },
        configdateTimePicker: {
            enableTime: true,
            dateFormat: 'Y-m-d'
        },
    }),
    components: {},
    mounted() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'));
        me.usuario_id = me.usuario[0].idusuario
        console.log(me.usuario_id)
        me.getAdmin();

    },
    methods: {
        getAdmin() {
            let me = this;
            me.$vs.loading()
            axios.get(this.$server_url + 'periodos?todo=yes')
                .then(function (response) {
                    me.periodoLista = response.data;
                    me.$vs.loading.close()
                    console.log(me.periodo);
                })
                .catch(function () {
                    me.$vs.loading.close()
                })
        },
        addPeriodo() {
            let me = this;
            me.update = false;
            me.popupActivo2 = true;
        },

        //para agregar periodo
        agregarPeriodo() {
            let me = this;
            let formData = new FormData();
            if (me.update) {
                formData.append('idperiodoescolar', me.id);
                formData.append('fecha_inicial', me.periodo.fecha_inicial);
                formData.append('fecha_final', me.periodo.fecha_final);
                formData.append('descripcion', me.periodo.descripcion);
                formData.append('region_idregion', me.periodo.region_idregion);
                formData.append('periodoescolar', me.periodo.periodoescolar);
            } else {
                formData.append('fecha_inicial', me.periodo2.fecha_inicial);
                formData.append('fecha_final', me.periodo2.fecha_final);
                formData.append('descripcion', me.periodo2.descripcion);
                formData.append('region_idregion', me.periodo2.region_idregion);
                formData.append('periodoescolar', me.periodo2.periodoescolar);
            }
            me.$vs.loading()
            axios.post(this.$server_url + 'periodos', formData)
                .then(() => {
                    // console.log(res.data)
                    me.getAdmin();
                    me.popupActivo1 = false
                    me.popupActivo2 = false
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: 'Periodo guardado exitosamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                })

        },

        openModal(data = {}) {
            this.popupActivo1 = true;
            if (this.update) {
                this.id = data.idperiodoescolar;
                this.titleModal = "Modificar Periodo";

                this.periodo.fecha_inicial = data.fecha_inicial;
                this.periodo.fecha_final = data.fecha_final;
                this.periodo.descripcion = data.descripcion;
                this.periodo.region_idregion = data.region_idregion;
                this.periodo.periodoescolar = data.periodoescolar;
                this.periodo.fromDate = data.finicio_limite;
                this.periodo.toDate = data.fhasta_limite;

            } else {
                this.id = 0;
                this.titleModal = "Crear Periodo";
                this.periodo.fecha_inicial = "";
                this.periodo.fecha_final = "";
                this.periodo.descripcion = "";
                this.periodo.region_idregion = "";
                this.periodo.periodoescolar = "";
                this.periodo.fromDate = null;
                this.periodo.toDate = null;
            }
        },
        openModalAdd() {
            let me = this;
            me.popupActivo1 = true;
            if (me.update) {
                me.titleModal = "Modificar Periodo";
            } else {
                me.id = 0;
                me.titleModal = "Crear Periodo";
            }
        },
        limpiarcampos() {
            this.id = 0;
            this.titleModal = "Crear Periodo";
            this.periodo.fecha_inicial = "";
            this.periodo.fecha_final = "";
            this.periodo.descripcion = "";
            this.periodo.region_idregion = "";
            this.periodo.periodoescolar = "";
            this.periodo.fromDate = "";
            this.periodo.toDate = "";
        },
        // desactivar el estado de la tabla 
        desactivar(idperiodoescolar) {
            let me = this;
            let formData = new FormData();
            formData.append('idperiodoescolar', idperiodoescolar);
            me.$vs.loading()
            axios.post(this.$server_url + 'periodo/desactivar', formData)
                .then(() => {
                    me.getAdmin();
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: 'Periodo  actualizado',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                })
        },
        activar(idperiodoescolar) {
            let me = this;
            let formData = new FormData();
            formData.append('idperiodoescolar', idperiodoescolar);
            me.$vs.loading()
            axios.post(this.$server_url + 'periodo/activar', formData)
                .then(() => {
                    me.getAdmin();
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: 'Periodo  actualizado',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                })
        },
    },
}
</script>
